import React from 'react';
import Navigation from '../../components/navigation'
import Layout from '../../components/index-layout'
import {Link} from 'react-router-dom'

import train_31 from './../../pic/train_31.jpg'
import train_32 from './../../pic/train_32.jpg'
import train_33 from './../../pic/train_33.jpg'
import train_51 from './../../pic/train_51.jpg'
import train_52 from './../../pic/train_52.jpg'
import train_53 from './../../pic/train_53.jpg'
import './index.css'
export default class train extends React.Component {
    state = {
        picList:[],
        picIndex:0,
        coverIndex:0
    }
    componentWillMount(){
        var list = [train_31,train_32,train_33,train_51,train_52,train_53]
        this.setState({picList:list})
    }
    togglePic=(index)=>{
        this.setState({picIndex:index})
    }
    toggleCover=(index)=>{
        this.setState({coverIndex:index})
    }
    render(){
        return (
            <main><Navigation tab="train"></Navigation><div className="train_container">
                    <div className="top">
                        <img src={this.state.picList[this.state.picIndex]} alt=""></img>
                        <div>
                            <p style={{fontSize:'22px'}}>培训知识</p>
                            <Link to="/train/1"><p onMouseEnter={this.togglePic.bind(this,0)} style={{color:(this.state.picIndex == 0 ? '#FF5D38' : '#E6E9F0')}}>几岁是练习击剑的最佳年龄？</p></Link>
                            <Link to="/train/2"><p onMouseEnter={this.togglePic.bind(this,1)} style={{color:(this.state.picIndex == 1 ? '#FF5D38' : '#E6E9F0')}}>孩子学击剑，家长从中扮演什么角色？</p></Link>
                            <Link to="/train/3"><p onMouseEnter={this.togglePic.bind(this,2)} style={{color:(this.state.picIndex == 2 ? '#FF5D38' : '#E6E9F0')}}>击剑教育对女孩的好处多！</p></Link>
                            <Link to="/train/4"><p onMouseEnter={this.togglePic.bind(this,3)} style={{color:(this.state.picIndex == 3 ? '#FF5D38' : '#E6E9F0')}}>幼少儿的击剑体能训练</p></Link>
                            <Link to="/train/5"><p onMouseEnter={this.togglePic.bind(this,4)} style={{color:(this.state.picIndex == 4 ? '#FF5D38' : '#E6E9F0')}}>古代剑术决斗｜带你领略击剑的魅力</p></Link>
                            <Link to="/train/6"><p onMouseEnter={this.togglePic.bind(this,5)} style={{color:(this.state.picIndex == 5 ? '#FF5D38' : '#E6E9F0')}}>都说击剑需要练体能，但体能究竟是个啥？</p></Link>
                        </div>
                    </div>
                    <div className="middle">
                        <Layout title="课程设置">
                            <div className="list">
                                <Link to="/train/class/1">
                                    <li>
                                        <img src={require('./../../pic/class_01.jpg')} alt=""></img>
                                        <div>
                                            <p>成人班</p>
                                            <p>适宜年龄：<b>18岁以上</b></p>
                                            <p>教学特色：根据成人运动和思维的特点进行制定训练计划。除了让学员熟练的掌握击剑的技战术以外，还要让学员体验冷兵器时代优雅的骑士精神，感受决斗的快感与胜利的喜悦。</p>
                                        </div>
                                    </li>
                                </Link>
                                <Link to="/train/class/2">
                                    <li>
                                        <img src={require('./../../pic/class_03.jpg')} alt=""></img>
                                        <div>
                                            <p>青少年班</p>
                                            <p>适宜年龄：<b>13岁~18岁</b></p>
                                            <p>教学特色：教练根据青少年阶段的年龄性格特点来制定教学计划，通过学习击剑技术使学员获得高度集中的注意力，用战术训练提高他们的逻辑思维能力。</p>
                                        </div>
                                    </li>
                                </Link>
                                <Link to="/train/class/3">
                                    <li>
                                        <img src={require('./../../pic/class_02.jpg')} alt=""></img>
                                        <div>
                                            <p>儿童班</p>
                                            <p>适宜年龄：<b>5岁~12岁</b></p>
                                            <p>教学特色：有助于培养和提高孩子的耐心、专注力和身体技能，使他们在击剑运动中更有竞争性，做到超越自我。</p>
                                        </div>
                                    </li>
                                </Link>
                            </div>
                        </Layout>
                    </div>
                    <div className="bottom">
                        <div>
                            <Layout title="机构风采">
                                <ul>
                                    <li>
                                        <Link to="/train/7">
                                        <img src={require('./../../pic/display01.jpg')} alt=""></img>
                                        <div className="content">
                                            <p>江苏省体育局青少处及苏州体育局领导莅临佐罗击剑俱乐部视察工作</p>
                                            <p>2019年9月11日下午，江苏省体育局青少处及苏州体育局诸位领导莅临佐罗击剑星海馆进行相关视察并指导工作。</p>
                                            <p></p>
                                        </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/train/8">
                                        <img src={require('./../../pic/display11.jpg')} alt=""></img>
                                        <div className="content">
                                            <p>【喜报！冠军！】祝贺许庭玮获得二青会男重甲组冠军！</p>
                                            <p>第二届全国青年运动会击剑比赛在8月9日山西省朔州市怀仁体育馆正式拉开帷幕。来自全国各地的36支体校队伍、58家社会俱乐部队伍和4名华人华侨共计500多名运动员参加比赛。</p>
                                            <p></p>
                                        </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/train/9">
                                        <img src={require('./../../pic/display21.jpg')} alt=""></img>
                                        <div className="content">
                                            <p>佐罗击剑俱乐部应邀参加FM91.1苏州新闻广播直播栏目《听运动的声音》</p>
                                            <p>9月8日（今天），佐罗击剑俱乐部副总经理黄静、教练经理杨汝杰以嘉宾的身份应邀参加FM91.1苏州新闻广播直播栏目《听运动的声音》，与主持人苏聆一起畅聊击剑这项优雅的体育项目。</p>
                                            <p></p>
                                        </div>
                                        </Link>
                                    </li>
                                </ul>
                            </Layout>
                        </div>
                        <div className="org_area">
                            <div className="left" onMouseEnter={this.toggleCover.bind(this,1)} onMouseLeave={this.toggleCover.bind(this,0)}>
                                <div className="name">久光馆</div>
                                {this.state.coverIndex == 1 &&
                                    <Link to="/train/venue/1"><div className="cover">
                                        <p>久光馆</p>
                                        <p>0512-67505113</p>
                                        <p>苏州园区旺墩路268号久光百货2楼黄蓝中庭北侧</p>
                                        <p>查看详情</p>
                                    </div></Link>
                                }
                            </div>
                            <div className="right">
                                <div onMouseEnter={this.toggleCover.bind(this,2)} onMouseLeave={this.toggleCover.bind(this,0)}>
                                    <div className="name">星海馆</div>
                                    {this.state.coverIndex == 2 &&
                                        <Link to="/train/venue/2"><div className="cover">
                                            <p>星海馆</p>
                                            <p>0521-68733059</p>
                                            <p>苏州园区星海街游泳馆3楼</p>
                                            <p>查看详情</p>
                                        </div></Link>
                                    }
                                </div>
                                <div onMouseEnter={this.toggleCover.bind(this,3)} onMouseLeave={this.toggleCover.bind(this,0)}>
                                    <div className="name">昆山馆</div>
                                    {this.state.coverIndex == 3 &&
                                        <Link to="/train/venue/3"><div className="cover">
                                            <p>昆山馆</p>
                                            <p>0512-57539589</p>
                                            <p>苏州昆山白马泾路46号欧尚超市3楼</p>
                                            <p>查看详情</p>
                                        </div></Link>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
};